import React from "react";

const SIZE_CLASS = {
  md: "w-[min(840px,94vw)]",
  lg: "w-[min(1100px,96vw)]",
  xl: "w-[min(1200px,97vw)]",
};

const Modal = ({ open, title, children, onClose, footer, size = "md", subtitle }) => {
  if (!open) return null;
  return (
    <div
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose && onClose();
      }}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/35 p-3"
    >
      <div
        onMouseDown={(e) => e.stopPropagation()}
        className={`flex max-h-[90vh] ${SIZE_CLASS[size] || SIZE_CLASS.md} flex-col rounded-xl bg-white shadow-xl`}
      >
        <div className="flex flex-shrink-0 items-start justify-between gap-3 border-b border-gray-200 p-4">
          <div className="min-w-0">
            <h3 className="m-0 text-base font-semibold text-gray-900">{title}</h3>
            {subtitle ? (
              <p className="mt-1 text-xs text-gray-500 truncate">{subtitle}</p>
            ) : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded hover:bg-gray-100"
          >
            <span className="text-xl leading-none">×</span>
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-4">{children}</div>
        {footer != null ? (
          <div className="flex flex-shrink-0 justify-end gap-2 border-t border-gray-200 p-4">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Modal;


